import axios from "axios"
import get from "lodash/get"
import URITemplate from "urijs/src/URITemplate"
import { urls } from "utils-lib/builds"
import {
  GET_CANCEL_SERVICE_ELIGIBILITY_FULFILLED,
  GET_CANCEL_SERVICE_ELIGIBILITY_FAILED,
  GET_CANCEL_SERVICE_ELIGIBILITY_PENDING,
  SET_IS_MOVING_FLOW,
  SET_IS_MOVING_LOGGED_IN_FLOW,
  SET_IS_CHECK_AVAILABILITY_BUTTON_CLICKED,
  SET_MOVING_END_DATE,
  SET_CANCEL_SELECTED_REASON,
  SET_IS_MOVING_STATE,
  SET_CANCEL_MOVING_BUTTON_CLICKED,
  SET_RESI_SAVE_CANCEL,
  SET_RESI_LOGOUT_STATE,
  RESET_CANCEL_SERVICE_ELIGIBILITY,
  RESET_SUBMIT_CANCEL_DETAILS,
  SET_SAME_ADDRESS_MOVING,
} from "constants-lib/actionTypes"
import { getTokenAction } from "actions-lib/getToken"

export const cancelServiceEligibilityPending = () => ({
  type: GET_CANCEL_SERVICE_ELIGIBILITY_PENDING,
})

export const cancelServiceEligibilityFailed = (error) => ({
  type: GET_CANCEL_SERVICE_ELIGIBILITY_FAILED,
  payload: error,
})

export const cancelServiceEligibilityFulfilled = (type, data) => ({
  type,
  payload: data,
})

export const setIsMovingFlow = (isMovingFlow) => ({
  type: SET_IS_MOVING_FLOW,
  payload: isMovingFlow,
})

export const setSameAddressMoving = (isSameAddress) => ({
  type: SET_SAME_ADDRESS_MOVING,
  payload: isSameAddress,
})

export const setIsMovingLoggedInFlow = (isMovingLoggedInFlow) => ({
  type: SET_IS_MOVING_LOGGED_IN_FLOW,
  payload: isMovingLoggedInFlow,
})

export const setCheckAvailabilityStateLoggedIn = (
  isCheckAvailabilityButtonClicked,
) => ({
  type: SET_IS_CHECK_AVAILABILITY_BUTTON_CLICKED,
  payload: isCheckAvailabilityButtonClicked,
})

export const setIsMovingState = (isFromMovingFlow) => ({
  type: SET_IS_MOVING_STATE,
  payload: isFromMovingFlow,
})

export const setCancelMovingButtonClicked = (isCancelMovingButtonClicked) => ({
  type: SET_CANCEL_MOVING_BUTTON_CLICKED,
  payload: isCancelMovingButtonClicked,
})

export const setResiSaveCancel = (isResiSaveCancel) => ({
  type: SET_RESI_SAVE_CANCEL,
  payload: isResiSaveCancel,
})

export const setCancelSelectedReason = (selectedReason) => ({
  type: SET_CANCEL_SELECTED_REASON,
  payload: selectedReason,
})

export const setResiLogoutState = () => ({
  type: SET_RESI_LOGOUT_STATE,
})

export const setMovingDate = (date) => ({
  type: SET_MOVING_END_DATE,
  payload: date,
})

export const resetCancelServiceEligibility = () => ({
  type: RESET_CANCEL_SERVICE_ELIGIBILITY,
})

export const resetSubmitCancelDetails = () => ({
  type: RESET_SUBMIT_CANCEL_DETAILS,
})

export const getCancelServiceEligibility =
  ({ customerId, LDFFReleaseEligiblityEntryMywmDashboard = false }) =>
  (dispatch, getState) => {
    dispatch(cancelServiceEligibilityPending())

    const api = `CANCEL_SERVICE_ELIGIBILITY`
    const apiKey = get(urls, `apiKey.USER.CANCEL_SERVICE_ELIGIBILITY`, ``)

    const template = URITemplate(urls.url[api])
    const state = getState()
    const locale = get(state, `siteLanguage.language`, ``)

    const url = template.expand({
      userId: get(state, `userAccount.userDetails.userId`, ``),
      customerId,
      lang: locale,
    })

    return getTokenAction(dispatch, getState).then((token) => {
      const config = {
        headers: {
          apiKey,
          oktaToken: token.accessToken,
        },
      }

      return axios
        .create(config)
        .get(url)
        .then((response) => {
          const data = LDFFReleaseEligiblityEntryMywmDashboard
            ? get(response, `data`, {})
            : get(response, `data.data`, {})
          dispatch(
            cancelServiceEligibilityFulfilled(
              GET_CANCEL_SERVICE_ELIGIBILITY_FULFILLED,
              data,
            ),
          )
          return data
        })
        .catch((error) => {
          const errorData = get(error, "response.data", {})
          dispatch(cancelServiceEligibilityFailed(errorData))
          return errorData
        })
    })
  }
